// extracted by mini-css-extract-plugin
export var actionButton = "_9z-0";
export var attachmentLine = "_9z-1";
export var fileInput = "_9z-2";
export var fileUploadWrapper = "_9z-4";
export var footer = "_9z-3";
export var modalContent = "_9z-5";
export var paperclip = "_9z-6";
export var quillEditor = "_9z-7";